var dataCast = {
  "Navigation": {
    "title": "Centro Médico Llucmajor",
    "queOfrecemos": 'Qué Ofrecemos',
    "quienesSomos": 'Quiénes Somos',
    "dondeEstamos": 'Dónde Estamos',
    "contacto": 'Contacto'
  },
  "Header": {

      "title": "Centro Médico Llucmajor",
      "paragraph": ["Cerramos del", "1 al 29 de Agosto", "Lunes - Viernes", "10:00 -13:00 y 17:00 -20:00","Sábado: 10:00 - 13:00"]

  },
  "About": {
      "title":"Sobre Nosotros",
      "paragraph": "El Centro Médico Llucmajor tiene más de 30 años de \
        experiencia en el sector y cuenta con la mejor de las equipaciones en revisiones médicas del \
        junto con un equipo de profesionales perfectamente cualificados en las \
        áreas de psicología, oftalmología, y medicina general. Situado \
        al lado de la parada de Llucmajor, es la mejor opción para renovar su \
        carnet de conducir, su licencia de armas, seguridad privada, extranjería, marina, \
        tenencia de animales peligrosos, grúas etc. Ofrecemos unos servicios rápidos y excelentes para \
        obtener los certificados médicos correspondientes.",
      "whyTitle":"¿Por qué Nosotros?",
      "Why": [
        "Rapidez",
        "Comodidad",
      ],
      "Why2": [
          "Variedad de servicios",
          "Experiencia"
      ]
  },
  "Cupon": {
    "title":"¡CONSIGUE UN CUPÓN DE DESCUENTO!",
    "click":"¡Haz click en la imagen!"
  },
  "Services": {
    "title": "Que Ofrecemos",
    "subtitle":"Para renovar el carnet de conducir del tipo A / B / C / D / E o BTP solo \
                le hará falta traer el DNI (aun caducado) y su carnet de conducir (en caso \
                de renovación). Nuestro centro médico se encargara del resto.",
    "services": [
      {
        "icon": "fa fa-car",
        "name": "Carnet de conducir",
        "text": ["Renovación de carnet de conducir.","Nuevos conductores: AM, A1, A, B."]
      },
      {
        "icon": "fa fa-stethoscope",
        "name": "Psicotécnicos",
        "text": ["Certificados psicotécnicos para licencias de armas, \
        licencias de embarcación, animales potencialmente peligrosos, \
        seguridad privada, vigilante, grúa, buceo, pesca...en este apartado encontrará \
        toda la información de los psicotécnicos."]
      },
      {
        "icon": "fa fa-heartbeat",
        "name": "Certificados Médicos",
        "text": ["Certificados médicos para todos los trámites: deportivos, escolares, \
        laborales, para adopciones, oposiciones, generales, para taxi, agentes de aduana... \
        en esta sección se describe toda la información relativa a los certificados médicos."]
      },
      {
        "icon": "fa fa-flash",
        "name": "Fácil",
        "text": ["Sin cita previa. Sin fotografías. Solo traiga su DNI y su carnet de conducir \
        y nosotros nos encargamos del resto."]
      },
      {
        "icon": "fa fa-coffee",
        "name": "Despreocúpese",
        "text": ["Nosotros mismos tramitamos su renovación del carnet de conducir (previo \
          pago de las tasas). Recibalo directamente en su domicilio, sin colas ni esperas \
          (envío realizado por la DGT)."]
      },
      {
        "icon": "fa fa-clock-o",
        "name": "Amplio horario",
        "text": ["Lun - Vier 10:00 - 13:00/17:00 -20:00","Sábado: 10:00 - 13:00","Al lado del metro "]
      }
    ]
  },
  "Contact": {
      "title":"Contacta con nosotros",
      "subTitle":"Porfavor, rellene el siguiente formulario para contactar \
                  con nosotros via email y le contestaremos lo antes posible.",
      "formData": {
        "name":"Nombre",
        "email":"Correo",
        "message":"Mensaje",
        "sendButton":"Enviar correo",
        "success":"Gracias!",
        "error":"Ooops! Ha habido un error.",
        "consent": "Acepto la política de privacidad y doy consentimiento para el tratamiento de datos.",
        "consentPrivacy": "Política de privacidad",
        "consentData": "Consentimiento de tratamiento de datos"
      },

      
      "contact": "Contacto",
      "addressLabel": "Dirección",
      "address": ["Pª Valldaura 218 - 220 2º4","Pª Verdum, 55-57  2º4ª","08042 Llucmajor, Barcelona"],
      "phoneLabel": "Teléfono",
      "phone": "+34 933537630",
      "emailLabel": "Correo",
      "email": "cmllucmajor@cmllucmajor.com",

      "facebook": "fb.com",
      "twitter": "twitter.com",
      "youtube": "youtube.com",
  },
  "Map": {
    "metro": " Estaciones de metro: Llucmajor (Línea 4)",
    "buses": "Autobuses: H4, H2, D40, D50, 47, V29, 76"
  },
  "Team":{
    "temporalDays": "CERRAMOS",
    "temporalHours": "1 Agosto - 29 Agosto",
    "firstDays": "LUNES A VIERNES",
    "firstHours": "10:00 - 13:00 y 17:00 - 20:00",
    "secondtDays": "SÁBADOS",
    "secondtHours": "10:00-13:00"
  },
  "Gallery": {
    "title":"PERMISOS",
    "intro": "Proporcionamos certificados médicos para Posesión de armas\
            Seguridad privada / vigilantes de seguridad,\
            Tenencia de animales peligrosos,\
            P.E.R,\
            Residencia,\
            Trabajo,\
            Oposiciones,\
            Conducción grúas,\
            Homologación de permisos extranjeros,\
            Deportes nivel 1, y \
            Pérdida de puntos. ",
    "images": [  
        {
            "text": "Coche",
            // "image": "img/portfolio/01-small.jpg",
            "image": "img/gallery/coche.png",
        },
        {
            "text": "Moto",
            // "image": "img/portfolio/01-small.jpg",
            "image": "img/gallery/moto.png",
        },
        {
            "text": "Camiones pesados",
            // "image": "img/portfolio/01-small.jpg",
            "image": "img/gallery/camion.png",
        },
        {
            "text": "Posesión de armas",
            // "image": "img/portfolio/01-small.jpg",
            "image": "img/gallery/armas.png",
        },
        {
            "text": "Seguridad privada / vigilantes de seguridad",
            "image": "img/gallery/seguridad.png",
        },
        {
            "text": "Tenencia se animales peligrosos",
            "image": "img/gallery/perro.png",
        },
        {
            "text": "P.E.R",
            "image": "img/gallery/per.png",
        },
        {
            "text": "Trabajo",
            "image": "img/gallery/working.png",
        },
        {
            "text": "Conducción grúas",
            "image": "img/gallery/grua.png",
        },
        {
            "text": "Homologación de permisos extranjeros",
            "image": "img/gallery/imigrantes.png",
        },
        {
            "text": "Residencia",
            "image": "img/gallery/residencia.png",
        },
        {
            "text": "Oposiciones",
            "image": "img/gallery/oposiciones.png",
        },
    ]
  },
  "Cookies":{
    "btnAccept": "Aceptar",
    "btnConfig": "Panel Cookies",
    "main": "Utilizamos cookies propias y de terceros para fines analíticos y \
            para mostrarle publicidad personalizada en base a un perfil elaborado \
            a partir de sus hábitos de navegación (por ejemplo, páginas visitadas).\
            Para más información consulte la",
    "link": "política de cookies",
    "configure": 'Puede aceptar todas las cookies pulsando el botón "Aceptar" o configurarlas \
                  o rechazar su uso pulsando el botón "Configurar"',
  }
}
export default dataCast